import type { NodeCategory } from '@bandos/shared'

/** Simplified node info for chat context */
export interface ChatContextNode {
  id: string
  label: string
  category: NodeCategory
  position: { x: number; y: number }
}

/** Simplified edge info for chat context */
export interface ChatContextEdge {
  id: string
  source: string
  target: string
}

/** Context sent with chat messages */
export interface ChatContext {
  nodes?: ChatContextNode[]
  edges?: ChatContextEdge[]
}

/** Token usage metrics returned by AI endpoints */
export interface UsageMetrics {
  model?: string
  promptTokens: number
  completionTokens: number
  totalTokens: number
}

/** Number of panels in a storyboard */
export const STORYBOARD_PANEL_COUNT = 4
